export default ({ app, store, redirect, route }) => {
  const isAuthenticated = store.getters['_core/auth/isAuthenticated'];
  if (isAuthenticated) {
    redirect({ query: route.query, path: '/' });
  }
};
